import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import { TNavigationStackWithParams } from 'app/types';
import { MainLayout } from '@shared/components/md-design-system/Layout/MainLayout';
import DrugIntakeFlow from "../components/activity/flow/DrugIntakeFlow"
import { ActivityName } from '../types';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';

const DrugIntakeFlowScreen = () => {
    const route = useRoute<RouteProp<TNavigationStackWithParams<{ activityName: ActivityName, activityId: string, initialStep: number }>, 'ActivitySubmit'>>();
    const navigation = useNavigation<NativeStackNavigationProp<TNavigationStackWithParams<undefined>>>();

    const activityName = route.params?.activityName;
    const initialStep = route.params?.initialStep || 0;
    const activityId = route.params?.activityId;

    const handleGoToHome = () => {
        navigation.navigate("Homepage");
    }
    
    return (
        <MainLayout navigation={handleGoToHome}>
            <DrugIntakeFlow activityName={activityName} activityId={activityId} initialStep={initialStep} />
        </MainLayout>
    );
};

export default DrugIntakeFlowScreen;